import {
    BooleanField,
    CreateButton,
    Datagrid,
    EditButton,
    Error,
    ExportButton,
    FormWithRedirect,
    FunctionField,
    List,
    RadioButtonGroupInput, NumberField,
    NumberInput,
    ReferenceInput,
    required,
    SaveButton,
    SelectInput,
    ShowButton,
    Tab,
    TabbedShowLayout,
    TextField,
    TextInput,
    TopToolbar,
    useCreate,
    useGetIdentity,
    useNotify,
    useRecordContext,
    useRefresh
} from "react-admin";
import {Button, LinearProgress} from "@material-ui/core";
import * as React from "react";
import {useEffect, useState} from "react";
import axios from "axios";
import {SERVER_URL} from "../../utils";
import {Button as ButtonRA} from "ra-ui-materialui/lib/button";
import AddToPhotosIcon from "@material-ui/icons/AddToPhotos";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import IconCancel from "@material-ui/icons/Cancel";
import {pageNavigationPlugin} from "@react-pdf-viewer/page-navigation";
import {printPlugin} from "@react-pdf-viewer/print";
import {searchPlugin} from "@react-pdf-viewer/search";
import {getFilePlugin} from '@react-pdf-viewer/get-file';
import {zoomPlugin} from "@react-pdf-viewer/zoom";
import {ProgressBar, Viewer} from "@react-pdf-viewer/core";
import styles from './label.css';

const FullNameField = (props) => {
    const record = useRecordContext(props);
    return <img src={record.img} width={150} alt="Etichetta Personalizzata"/>;
}
const ToolbarButtons = () => {
    const [showDialog, setShowDialog] = useState(false);
    const {loaded, identity, loading: identityLoading} = useGetIdentity();
    const [create, {loading}] = useCreate();
    const notify = useNotify();
    const refresh = useRefresh();
    //const form = useForm();

    const handleClick = () => {
        setShowDialog(true);
    };

    const handleCloseClick = () => {
        setShowDialog(false);
    };

    const handleSubmit = async values => {
        if (!values.Etichetta || (values.Etichetta == 2 && !identity.img)) {
            alert("L'etichetta selezionata non è valida");
            return;
        }
        if (values.Numero <= 0) {
            alert('Il numero di color code deve essere maggiore di zero!');
            return;
        }
        const res = await axios.post(SERVER_URL + "/api/v1/merchandise/generate_label/" + values.Numero + "/" +
            values.Lotto + "/" + values.warranty.id + "/" + (values.product ? values.product.id : "-") + "/" + values.Dimensione + "/" + values.Etichetta + "/",
            {}, {
                withCredentials: true,
            });
        setShowDialog(false);
        refresh();
    };

    return (
        <>
            <TopToolbar>
                <ButtonRA onClick={handleClick} label="Genera">
                    <AddToPhotosIcon/>
                </ButtonRA>
            </TopToolbar>
            <Dialog
                fullWidth
                open={showDialog}
                onClose={handleCloseClick}
                aria-label="Create post"
            >
                <DialogTitle>Genera ColorCode</DialogTitle>

                <FormWithRedirect
                    resource="colorcode"
                    save={handleSubmit}
                    render={({
                                 handleSubmitWithRedirect,
                                 pristine,
                                 saving
                             }) => (
                        <>
                            <DialogContent>
                                <div style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignContent: "center",
                                    flexDirection: "column"
                                }}>Quanti CC vuoi generare? <NumberInput source={"Numero"} validate={required()}/>
                                </div>
                                <TextInput source={"Lotto"} validate={required()} fullWidth/>
                                <ReferenceInput source="warranty.id" reference="warranty" label="Garanzia"
                                                fullWidth>
                                    <SelectInput optionText="description" disableValue="not_available"/>
                                </ReferenceInput>
                                <ReferenceInput source="product.id" reference="product" label="Prodotto"
                                                fullWidth>
                                    <SelectInput optionText="productName" disableValue="not_available"/>
                                </ReferenceInput>
                                <div style={{display: "flex", justifyContent: "center", width: "100%"}}>
                                    <RadioButtonGroupInput source="Dimensione" choices={[
                                        {id: 0, name: "SINGOLA"},
                                        {id: 1, name: "A4"},
                                        {id: 2, name: "A3"},
                                    ]} defaultValue={1}
                                                           fullWidth={true}
                                                           translateChoice={false}
                                                           />
                                </div>
                                <div style={{display: "flex", justifyContent: "center", width: "100%"}}>
                                    <RadioButtonGroupInput source="Etichetta" choices={[
                                        {id: 1, img: "label.png"},
                                        {id: 2, img: identity.img ? identity.img : ""},
                                    ]}
                                                           defaultValue={1}
                                                           fullWidth={true}
                                                           translateChoice={false}
                                                           optionText={<FullNameField/>}/>
                                </div>
                            </DialogContent>
                            <DialogActions>
                                <Button
                                    label="ra.action.cancel"
                                    onClick={handleCloseClick}
                                    disabled={loading}
                                >
                                    <IconCancel/>
                                </Button>
                                <SaveButton
                                    label={"Genera"}
                                    handleSubmitWithRedirect={
                                        handleSubmitWithRedirect
                                    }
                                    pristine={pristine}
                                    saving={saving}
                                    disabled={loading}
                                />
                            </DialogActions>
                        </>
                    )}
                />
            </Dialog>
        </>
    );
}

const postFilters = [
    <TextInput source="q" label="Cerca" alwaysOn/>,
];

const RegenerateLabel = (props) => {
    const record = useRecordContext(props);
    const regenerateApiCall = async () => {
        const res = await axios.post(SERVER_URL + "/api/v1/merchandise/refresh_label/" + record.id + "/",
            {}, {
                withCredentials: true,
            });
        fetch(SERVER_URL + "/api/v1/merchandise/refresh_label/" + record.id + "/", {
            method: "POST",
            credentials: 'include'
        }).then((res) => {
            return res.text();
        }).then((data) => {
            alert(data);
        });
    }

    return <ButtonRA label={"Rigenera"} onClick={regenerateApiCall}/>
}

export const LabelList = (props) => {
    return (
        <List {...props} perPage={25} filters={postFilters} empty={<ToolbarButtons/>} actions={<ToolbarButtons/>}>
            <Datagrid rowClick="">
                <FunctionField label="Data Generazione"
                               render={record => `${new Date(...record.generationDate).toLocaleString("it-IT").replace(",", "").replace(/:.. /, " ")}`}/>
                <NumberField label={"Numero Color-Code"} source={"ncolorCodes"}/>
                <ShowButton label="Visualizza Etichetta"/>
                <RegenerateLabel/>
            </Datagrid>
        </List>
    );
}

export const ShowLabel = (
    {
        id
    }
) => {
    const [label, setLabel] = useState(null);
    let labelPDFURL;
    const [pageNavigationPluginInstance] = useState(pageNavigationPlugin());
    const [printPluginInstance] = useState(printPlugin());
    const [searchPluginInstance] = useState(searchPlugin());
    const [zoomPluginInstance] = useState(zoomPlugin());
    const {GoToFirstPage, GoToLastPage, GoToNextPage, GoToPreviousPage} = pageNavigationPluginInstance;
    const {Print} = printPluginInstance;
    const {ShowSearchPopoverButton} = searchPluginInstance;
    const {ZoomInButton, ZoomOutButton, ZoomPopover} = zoomPluginInstance;
    const getFilePluginInstance = getFilePlugin();
    const {DownloadButton} = getFilePluginInstance;

    useEffect(async () => {
        fetch(SERVER_URL + "/api/v1/merchandise/download_label/" + id + "/", {
            method: "GET",
            credentials: 'include'
        }).then((res) => {
            return res.text();
        }).then((data) => {
            setLabel(data);
        });
    }, []);
    if (!label) return <>loading...</>;
    const labelPDF = base64toBlob(label);
    if (labelPDF)
        labelPDFURL = URL.createObjectURL(labelPDF);


    return (<div
        style={{
            border: '1px solid rgba(0, 0, 0, 0.3)',
            height: window.innerHeight,
        }}
    >
        <div style={{display: "flex", justifyContent: "center"}}>
            <ShowSearchPopoverButton/>
            <ZoomInButton/>
            <ZoomOutButton/>
            <ZoomPopover/>
            <GoToFirstPage/>
            <GoToLastPage/>
            <GoToNextPage/>
            <GoToPreviousPage/>
            <Print/>
            <DownloadButton/>
        </div>
        <Viewer fileUrl={labelPDFURL}
                plugins={[pageNavigationPluginInstance, printPluginInstance, searchPluginInstance, zoomPluginInstance, getFilePluginInstance]}
                renderLoader={(percentages) => (
                    <div style={{width: '240px'}}>
                        <ProgressBar progress={Math.round(percentages)}/>
                    </div>
                )}
        />
    </div>);
}

const base64toBlob = (data) => {
        // Cut the prefix `data:application/pdf;base64` from the raw base 64
        if (!data) return null;
        const base64WithoutPrefix = data.substr('data:application/pdf;base64,'.length);

        const bytes = atob(base64WithoutPrefix);
        let length = bytes.length;
        let out = new Uint8Array(length);

        while (length--) {
            out[length] = bytes.charCodeAt(length);
        }

        return new Blob([out], {type: 'application/pdf'});
    }
;

